export default "__VITE_ASSET__aee0c9f2__$_?component__"